import { IServicesIaPlansBackendRequestDto, IServicesIaPlansBackendResponse } from '../interfaces/IServicesIaPlansBackend';

export const servicesIaPlansMapper = {
    toDto: (values: any): IServicesIaPlansBackendRequestDto => {
        return {
            name: values.name,
            description: values.description,
            monthlyPrice: values.monthlyPrice !== '' ? Number(values.monthlyPrice) : 0,
            currency: values.currency?.value || values.currency || 'USD',
            monthlyCredits: values.monthlyCredits !== '' ? Number(values.monthlyCredits) : 0,
            durationDays: values.durationDays !== '' ? Number(values.durationDays) : undefined,
            maxRequestsDay: values.maxRequestsDay !== '' ? Number(values.maxRequestsDay) : undefined,
            maxRequestsMonth: values.maxRequestsMonth !== '' ? Number(values.maxRequestsMonth) : undefined,
            maxAssistants: values.maxAssistants !== '' ? Number(values.maxAssistants) : undefined,
            maxAgents: values.maxAgents !== '' ? Number(values.maxAgents) : undefined,
            maxUsers: values.maxUsers !== '' ? Number(values.maxUsers) : undefined,
            allowChat: values.allowChat,
            allowImages: values.allowImages,
            allowAudio: values.allowAudio,
            allowDocuments: values.allowDocuments,
            allowEmbeddings: values.allowEmbeddings,
            allowMemory: values.allowMemory,
            allowTools: values.allowTools,
            allowRag: values.allowRag,
            sortOrder: values.sortOrder !== '' ? Number(values.sortOrder) : 0,
        };
    },
    toDomain: (item: IServicesIaPlansBackendResponse): any => {
        return {
            id: item.id,
            name: item.name,
            description: item.description,
            monthlyPrice: item.monthlyPrice,
            currency: item.currency,
            monthlyCredits: item.monthlyCredits,
            durationDays: item.durationDays,
            maxRequestsDay: item.maxRequestsDay,
            maxRequestsMonth: item.maxRequestsMonth,
            maxAssistants: item.maxAssistants,
            maxAgents: item.maxAgents,
            maxUsers: item.maxUsers,
            allowChat: item.allowChat,
            allowImages: item.allowImages,
            allowAudio: item.allowAudio,
            allowDocuments: item.allowDocuments,
            allowEmbeddings: item.allowEmbeddings,
            allowMemory: item.allowMemory,
            allowTools: item.allowTools,
            allowRag: item.allowRag,
            sortOrder: item.sortOrder,
            status: item.status,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt
        };
    }
};
